import DeliveryOrderRoute from './DeliveryOrderRoute'

const routes = [
    new DeliveryOrderRoute()
]

export default routes
